import { useRef, useEffect } from 'react';
import type { RecipeMetrics } from '~/lib/network/funnel-report';

interface RawDataModalProps {
  metrics: RecipeMetrics | null;
  isOpen: boolean;
  onClose: () => void;
}

const RECIPE_TITLES: Record<string, string> = {
  aov_concentration: 'AOV Concentration',
  repeat_purchase: 'Repeat Purchase',
  payment_failures: 'Payment Failures',
  checkout_abandonment: 'Checkout Abandonment',
  cod_vs_prepaid: 'COD vs Prepaid',
  rto_returns: 'Refunds & Returns',
};

export function RawDataModal({ metrics, isOpen, onClose }: RawDataModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (isOpen) {
      dialog.showModal();
    } else {
      dialog.close();
    }
  }, [isOpen]);

  // Handle clicking outside modal
  const handleBackdropClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    const dialog = dialogRef.current;
    if (dialog && e.target === dialog) {
      onClose();
    }
  };

  if (!metrics) return null;

  const title = RECIPE_TITLES[metrics.recipe_name] || metrics.recipe_name;

  return (
    <dialog
      ref={dialogRef}
      className="modal"
      onClick={handleBackdropClick}
      onClose={onClose}
    >
      <div className="modal-box max-w-2xl">
        <form method="dialog">
          <button
            className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
            onClick={onClose}
          >
            ✕
          </button>
        </form>

        <h3 className="font-bold text-lg mb-4">{title} - Raw Data</h3>

        <div className="bg-base-200 rounded-lg p-4 overflow-auto max-h-[60vh]">
          <pre className="text-xs text-base-content/80 whitespace-pre-wrap">
            {JSON.stringify(metrics.metrics, null, 2)}
          </pre>
        </div>

        <div className="modal-action">
          <button className="btn btn-sm" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </dialog>
  );
}
